/**
 * Created by r4zi4l on 21.06.2021
 */

const ChestTimeMissionWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;
        this.pack = ChestTimeMissionWindow.PACK;

        this._super({
            name: "ChestTimeMissionWindow",
            content: this.createContent(),
            title: Messages.get("ChestTimeMissionWindow.title"),
            noBackground: true,
            contentPadding: cleverapps.styles.ChestTimeMissionWindow.contentPadding[cleverapps.resolution.mode],
            notCloseByTouchInShadow: true,
            closeButtonDelay: true,
            openSound: bundles.chesttime.urls.gin_energy_time
        });
    },

    getPerson: function () {
        return cleverapps.config.name === "mergecraft" ? "jihn" : "worker";
    },

    createContent: function () {
        const styles = cleverapps.styles.ChestTimeMissionWindow;

        const container = this.container = new cc.Node();
        container.setContentSize2(styles);
        container.setAnchorPoint(0.5, 0.5);

        const animation = new cleverapps.Spine(bundles.chesttime.jsons.energy_animation);
        animation.setAnchorPoint(0.5, 0.5);
        animation.setAlignment(styles.animation);
        animation.setAnimation(0, "animation", true);
        container.addChild(animation);

        const description = cleverapps.UI.generateOnlyText(Messages.get("ChestTimeMissionWindow.description"), cleverapps.styles.FONTS.CHESTTIMEMISSIONWINDOW_DESCRIPTION_TEXT);
        description.setAnchorPoint(0.5, 0.5);
        description.setAlignment(styles.description);
        description.setDimensions(styles.description.width, 0);
        description.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        container.addChild(description);

        if (cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL) {
            this.addPack();
        }

        return container;
    },

    addPack: function () {
        const styles = cleverapps.styles.ChestTimeMissionWindow;

        const pack = this.packView = this.createPack();
        cleverapps.UI.wrap(pack);
        pack.setAlignment(styles.pack);
        this.container.addChild(pack);
    },

    refreshPack: function () {
        if (this.packView) {
            this.packView.removeFromParent();
        }
        this.addPack();
    },

    createPack: function () {
        const styles = cleverapps.styles.ChestTimeMissionWindow.pack;

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);

        const title = cleverapps.UI.generateOnlyText(Messages.get("ChestTimeMissionWindow.packTitle"), cleverapps.styles.FONTS.CHESTTIMEMISSIONWINDOW_TITLE_TEXT);
        title.fitTo(styles.title.text.width);
        title.setAlignment(styles.title.text);
        title.setLocalZOrder(1);

        if (styles.title.noBg) {
            container.addChild(title);
        } else {
            const ribbon = new cc.Sprite(bundles.chesttime.frames.purple_ribbon);
            container.addChild(ribbon);
            ribbon.setAlignment(styles.title);
            ribbon.addChild(title);
        }

        let energyPack;

        if (bundles.chesttime.jsons.energy_pack) {
            energyPack = new cleverapps.Spine(bundles.chesttime.jsons.energy_pack);
            energyPack.setAnimation(0, "animation", true);
            container.addChild(energyPack);
        } else if (bundles.chesttime.frames.energy_pack) {
            energyPack = new cc.Sprite(bundles.chesttime.frames.energy_pack);
            container.addChild(energyPack);
        }

        const icon = new cc.Sprite(bundles.reward_icons.frames.treasure_chest_png);
        icon.setScale(styles.energyReward.icon.scale);

        const amount = cleverapps.UI.generateImageText(`x${this.pack.prizes.unit[0].amount}`, cleverapps.styles.FONTS.CHESTTIMEMISSIONWINDOW_REWARD_TEXT);

        const energyReward = new cleverapps.Layout([icon, amount], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        energyReward.setAlignment(styles.energyReward);
        container.addChild(energyReward);

        const cooldownLeft = this.mission.logic.getPackCooldownLeft();
        if (cooldownLeft > 0) {
            this.createCooldown(container, cooldownLeft);
        } else {
            this.createBuyButton(container);
        }

        return container;
    },

    createBuyButton: function (container) {
        const styles = cleverapps.styles.ChestTimeMissionWindow.pack;

        const buyPackButton = new UseGoldButton({
            price: this.pack.price,
            eventName: `${cleverapps.EVENTS.SPENT.OFFER}_${this.mission.getName()}`,
            onClicked: this.buyPackProduct.bind(this),
            filter: this.canBuyProduct.bind(this),
            width: styles.buyPackButton.width,
            height: styles.buyPackButton.height
        });
        buyPackButton.setAnchorPoint(0.5, 0.5);
        buyPackButton.setAlignment(styles.buyPackButton);
        container.addChild(buyPackButton);
    },

    createCooldown: function (container, cooldownLeft) {
        const styles = cleverapps.styles.ChestTimeMissionWindow.pack;
        const buttonStyles = styles.buyPackButton;
        const cooldown = styles.cooldown;

        const button = new cleverapps.UI.Button({
            text: Messages.get("SoldOut"),
            disabled: true,
            width: buttonStyles.width,
            height: buttonStyles.height
        });
        button.setAnchorPoint(0.5, 0.5);
        button.setAlignment(cooldown.button);
        container.addChild(button);

        const title = cleverapps.UI.generateOnlyText(Messages.get("ChestTimeMissionWindow.availableIn"), cleverapps.styles.FONTS.CHESTTIMEMISSIONWINDOW_COOLDOWN_TEXT);
        const icon = new cc.Sprite(bundles.small_timer.frames.small_timer_png);
        icon.setScale(cooldown.timer.icon.scale);
        const countDown = new cleverapps.CountDown(cooldownLeft, { onFinish: this.refreshPack.bind(this) });
        const countDownView = new cleverapps.CountDownView(countDown, {
            font: cleverapps.styles.FONTS.CHESTTIMEMISSIONWINDOW_COOLDOWN_TEXT,
            showHours: false
        });

        const timer = new cleverapps.Layout([title, icon, countDownView], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cooldown.timer.margin
        });
        icon.x += cooldown.timer.icon.dx;
        icon.y += cooldown.timer.icon.dy;
        timer.setAlignment(cooldown.timer);
        container.addChild(timer);
    },

    canBuyProduct: function () {
        if (this.pack.prizes.unit) {
            const items = this.pack.prizes.unit.reduce((sum, reward) => sum + (reward.amount || 0), 0);

            const notEnough = items - Map2d.currentMap.countEmptySlots();
            if (notEnough > 0) {
                cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left: notEnough }));
                return false;
            }
        }
        return true;
    },

    buyPackProduct: function () {
        this.mission.logic.startPackCooldown();

        this.close();

        cleverapps.focusManager.display({
            focus: "RewardWindow",
            stack: true,
            action: (f) => {
                new RewardWindow(this.pack.prizes);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    listBundles: function () {
        return ["chesttime"];
    }
});

ChestTimeMissionWindow.PACK = {
    price: 225,
    prizes: {
        unit: [
            { code: "treasure", stage: 2, amount: 3 }
        ]
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CHESTTIMEMISSIONWINDOW_TITLE_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    CHESTTIMEMISSIONWINDOW_DESCRIPTION_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    CHESTTIMEMISSIONWINDOW_REWARD_TEXT: {
        size: 50,
        name: "default"
    },

    CHESTTIMEMISSIONWINDOW_COOLDOWN_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.ChestTimeMissionWindow = {
    width: 1200,
    height: 550,

    contentPadding: [{
        left: 200,
        right: 200
    }, {
        left: 200,
        right: 200
    }, {
        left: 200,
        right: 200
    }],

    animation: {
        x: { align: "center", dx: 20 },
        y: { align: "center", dy: 0 }
    },

    description: {
        x: { align: "center" },
        y: { align: "center", dy: -450 },
        width: 1200
    },

    pack: {
        margin: 10,
        x: { align: "center", dx: 580 },
        y: { align: "center" },

        title: {
            x: { align: "center" },
            y: { align: "center", dy: 175 },
            text: {
                x: { align: "center" },
                y: { align: "center", dy: 17 },
                width: 280
            }
        },

        energyReward: {
            x: { align: "center" },
            y: { align: "center", dy: -142 },

            icon: {
                scale: 1.0
            }
        },

        buyPackButton: {
            x: { align: "center" },
            y: { align: "center", dy: -250 },
            width: 230,
            height: 100
        },

        cooldown: {
            button: {
                x: { align: "center" },
                y: { align: "center", dy: -310 }
            },
            timer: {
                x: { align: "center" },
                y: { align: "center", dy: -224 },
                margin: 8,
                icon: {
                    scale: 1,
                    dx: 2,
                    dy: 0
                }
            }
        }
    }
};
